<template>
  <div class="board_wrap">
    <div class="board_title">
      <h1>공지사항</h1>
    </div>
    <router-view name="listVue"></router-view>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.board_btn .btn_write {
  display: none;
}
</style>
